/**
 * Galería de juegos imprimibles de Baby Shower Dulce Recuerdo.
 * Para cambiar una página, reemplazá la URL de `src`.
 * Si `src` queda vacío, se muestra un placeholder identificado.
 */
export const babyShowerGames = [{
  title: 'Bingo Baby Shower',
  src: 'https://cdn.magicpatterns.com/uploads/3QjcdMrhpJutk5NL7A5c5m/image.png'
}, {
  title: '¿Quién conoce más a mamá?',
  src: 'https://cdn.magicpatterns.com/uploads/x2VzmSNeAdJaoBn9Noc28L/image.png'
}, {
  title: 'Predecí al bebé',
  src: 'https://cdn.magicpatterns.com/uploads/mieBxMCobbJEGGSZtQhKFS/image.png'
}, {
  title: 'Diseñá el body',
  src: 'https://cdn.magicpatterns.com/uploads/ovnZiwuEybCfs6wW97qNfK/image.png'
}, {
  title: 'Memoria',
  src: 'https://cdn.magicpatterns.com/uploads/7iE2J1hVS1v4QMAc1aTn1P/image.png'
}, {
  title: 'Crucigrama',
  src: 'https://cdn.magicpatterns.com/uploads/koYV4qry3FgroTxXE5JhUQ/image.png'
}, {
  title: 'Ruleta',
  src: 'https://cdn.magicpatterns.com/uploads/tCYaGDAopfTTxZbCwvNCMH/Baby_Shower_Dulce_Recuerdo_NENA_compressed-87_page-0001.jpg'
}, {
  title: "Trivia Famosos y más!",
  src: 'https://cdn.magicpatterns.com/uploads/3W1NUx1qrVQTe7n6vYAAwy/Baby_Shower_Dulce_Recuerdo_NENE_compressed-47_page-0001.jpg'
}];